import { proxy } from "valtio";
import { devtools } from "valtio/utils";

const ENV_DEV = "dev";
const ENV_RECETTE = "recette";

type GeneralStoreType = {
    ticketHeaderSaleModeBold: boolean;
    ticketHeaderSaleModeBlackBackround: boolean;
    ticketHeaderName_phone_number_bold: boolean;
    ticketHeaderPathCustomer: string;
    ticketHeaderPathKitchen: string;
    ticketHeaderLogoCustomer: boolean;
    ticketHeaderLogoKitchen: boolean;
    NumberCustomer: number;
    NumberTicketsKitchen: number;
    typeLogoCustomer: string;
    typeLogoKitchen: string;
    ticketHeaderStyleOrderNumber: boolean;
    printerInformationMode: boolean;
    printerBold: boolean;
};

const GENERAL_DEFAULTS: GeneralStoreType = {
    ticketHeaderSaleModeBold: false,
    ticketHeaderSaleModeBlackBackround: false,
    ticketHeaderName_phone_number_bold: false,
    ticketHeaderPathCustomer: "",
    ticketHeaderPathKitchen: "",
    ticketHeaderLogoCustomer: false,
    ticketHeaderLogoKitchen: false,
    NumberCustomer: 1,
    NumberTicketsKitchen: 1,
    typeLogoCustomer: "",
    typeLogoKitchen: "",
    ticketHeaderStyleOrderNumber: false,
    printerInformationMode: false,
    printerBold: false,
};

export const generalStore = proxy<GeneralStoreType>({ ...GENERAL_DEFAULTS });

if (
    process.env.REACT_APP_VERIFY === ENV_DEV ||
    process.env.REACT_APP_VERIFY === ENV_RECETTE
) {
    devtools(generalStore);
}

export function setTicketHeaderStyleOrderNumber(value: boolean): void {
    generalStore.ticketHeaderStyleOrderNumber = value;
}
export function setPrinterBold(value: boolean): void {
    generalStore.printerBold = value;
}
export function setPrinterInformationMode(value: boolean): void {
    generalStore.printerInformationMode = value;
}
export function setTicketHeaderSaleModeBold(value: boolean): void {
    generalStore.ticketHeaderSaleModeBold = value;
}
export function setTicketHeaderSaleModeBlackBackround(value: boolean): void {
    generalStore.ticketHeaderSaleModeBlackBackround = value;
}
export function setTicketHeaderName_phone_number_bold(value: boolean): void {
    generalStore.ticketHeaderName_phone_number_bold = value;
}
export function setTicketHeaderPathCustomer(value: string): void {
    generalStore.ticketHeaderPathCustomer = value;
}
export function setTicketHeaderPathKitchen(value: string): void {
    generalStore.ticketHeaderPathKitchen = value;
}
export function setTicketHeaderLogoCustomer(value: boolean): void {
    generalStore.ticketHeaderLogoCustomer = value;
}
export function setTicketHeaderLogoKitchen(value: boolean): void {
    generalStore.ticketHeaderLogoKitchen = value;
}
export function setAutomaticPrintingNumberCustomer(value: number): void {
    generalStore.NumberCustomer = value;
}
export function setAutomaticPrintingNumberTickets(value: number): void {
    generalStore.NumberTicketsKitchen = value;
}
export function setTypeLogoCustomer(value: string): void {
    generalStore.typeLogoCustomer = value;
}
export function setTypeLogoKitchen(value: string): void {
    generalStore.typeLogoKitchen = value;
}

export function resetGeneralStore(): void {
    Object.assign(generalStore, GENERAL_DEFAULTS);
}
